import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Maps Mirage Scenario
 * - `MIRAGE_SCENARIO=maps yarn start:mirage`
 *
 * @param {object} server   Mirage Server
 * @param {object} options  Options for visitors-classic scenario
 */

export default function (
  server,
  options = {
    areaMapTrait: 'withMapFloors',
    withDeliveriesSubscription: true,
    withRoomsSubscription: true,
    withDesksSubscription: true,
  }
) {
  const {
    company,
    subscription: vrSubscription,
    deliveriesSubscription,
    locations,
  } = visitorsClassicScenario(server, {
    ...options,
  });

  const [SFLocation, NYLocation] = locations;

  if (options.withDeliveriesSubscription) {
    server.create('notification-config', { location: SFLocation });
    server.create('notification-config', { location: NYLocation });

    server.create('delivery-area', { name: 'Delivery Area 1', location: SFLocation, locationName: SFLocation.name });
    server.create('delivery-area', {
      name: 'Delivery Area 2nd floor',
      location: SFLocation,
      locationName: SFLocation.name,
    });
    server.create('delivery-area', {
      name: 'Delivery Area back door',
      location: NYLocation,
      locationName: NYLocation.name,
    });
  }

  let roomsSubscription;
  if (options.withRoomsSubscription) {
    roomsSubscription = server.create('subscription', 'asStandard', {
      companyId: company.id,
      app: 'rooms',
    });
    server.createList('room', 4, {
      location: SFLocation,
    });
  }

  let desksSubscription;
  if (options.withDesksSubscription) {
    desksSubscription = server.create('subscription', 'asDesksSubscribed', 'asStandard', {
      companyId: company.id,
      quantity: 3,
    });

    server.createList('amenity', 5);
    server.createList('neighborhood', 5, { location: SFLocation });
  }

  const areaMap = server.create('area-map', options.areaMapTrait, { entityId: SFLocation.id });

  return {
    areaMap,
    company,
    subscriptions: [vrSubscription, deliveriesSubscription, roomsSubscription, desksSubscription],
    locations,
  };
}
